export default __webpack_public_path__ + "static/media/loader.3d5a7f76.gif";